        
import usePostForm from '../use-post-form';
import ConfirmationPopover from './ConfirmationPopover';


const PostFormButton = ({ url, alter_url_func, formData, callbackFunc, className, action_icon, children, confirm_delete=false, disabled=false, ...props}) =>{
    const {isLoading, error, sendRequest} = usePostForm(callbackFunc)

    const executeSubmit = () => {
        if(alter_url_func){
            url = alter_url_func(url)
        }
        if(formData && !(formData instanceof FormData)){
            const formDataValue = new FormData()
            Object.keys(formData).forEach( (key) => {
                if(Array.isArray(formData[key])){
                    formData[key].forEach( (value) => {
                        formDataValue.append(key, value)
                    })
                } else {
                    formDataValue.append(key, formData[key])
                }
            })
            formData = formDataValue
        }
        sendRequest(url, formData)
    }
    
    const onSubmit = (e) => {
        if(disabled) return
        e.preventDefault()
        if(confirm_delete){
            // Don't execute submit here - let the confirmation popover handle it
            return
        }
        executeSubmit()
    }
    disabled = isLoading || disabled
    
    if(confirm_delete) {
        return (
            <ConfirmationPopover
                onConfirm={executeSubmit}
                title="Confirm Delete"
                message="Are you sure you want to delete this object?"
                confirmText="Delete"
                cancelText="Cancel"
                confirmVariant="danger"
                cancelVariant="secondary"
                placement="top"
            >
                <a type="button" disabled={disabled} className={`${disabled ? 'disabled' : ''} action-button ${className}`}>
                    {children}
                </a>
            </ConfirmationPopover>
        )
    }
    
    return (
        <a type="button" disabled={disabled} onClick={onSubmit} className={`${disabled ? 'disabled' : ''} action-button ${className}`}>
            {children}
        </a>
    )
}

export default PostFormButton;